import styled, { createGlobalStyle } from "styled-components";
import { Fragment } from "react";
import { ISubAccountData } from "@/store/SubAccountStore";
import { TranferType } from "@/pages/child-customer/view/child-manage/components/child-operation/constants/transfer";
import { StatusButton } from "@/pages/child-customer/view/child-manage/components/child-operation/components/status-button";
import { TransferButton } from "@/pages/child-customer/view/child-manage/components/child-operation/components/transfer-button";
import {
  EditChildButton,
  EditChildModal,
} from "@/pages/child-customer/view/child-manage/components/child-operation/components/edit-child-button";
import { EditPermissionButton } from "@/pages/child-customer/view/child-manage/components/child-operation/components/edit-permission-button";
import {
  UnregisterButton,
  UnregisterModal,
} from "@/pages/child-customer/view/child-manage/components/child-operation/components/unregister-button";
import {
  SafetySettingButton,
  SafetySettingModal,
} from "@/pages/child-customer/view/child-manage/components/child-operation/components/safety-setting-button";
import {
  CreditButton,
  CreditModal,
} from "@/pages/child-customer/view/child-manage/components/child-operation/components/credit-button";
import { HiadeAssetButton } from "@/pages/child-customer/view/child-manage/components/child-operation/components/hide-asset-button";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import DownOutlinedIcon from "@/assets/icons/profile/down-outlined";
import { Dropdown } from "@renderbus/ui";
import { useChildOperation } from "./hooks/use-child-operation";

export function ChildOperation(row: ISubAccountData) {
  const {
    openCredit,
    setOpenCredit,
    openEditChild,
    setOpenEditChild,
    openSafetySetting,
    setOpenSafetySetting,
    openUnregister,
    setOpenUnregister,
  } = useChildOperation();
  const t = getTranslateNsT("center");
  return (
    <Fragment>
      <OperationWrapper>
        <StatusButton
          id={row.id}
          status={row.status}
          isDingTalkSubAccount={row?.isDingTalk}
          deptId={row?.deptId}
        />
        <TransferButton
          {...row}
          type={TranferType.TRANSFER_IN}
          isDingTalkSubAccount={row?.isDingTalk}
        />
        <TransferButton
          {...row}
          type={TranferType.TRANSFER_OUT}
          isDingTalkSubAccount={row?.isDingTalk}
        />
        <EditPermissionButton {...row} isDingTalk={row?.isDingTalk} />
      </OperationWrapper>
      <OperationWrapper>
        <HiadeAssetButton {...row} />
        <MoreOperationWrapper>
          <Dropdown
            dropdownRender={() => (
              <ButtonWrapper onClick={() => {}}>
                <CreditButton onClick={() => setOpenCredit(true)} />
                <SafetySettingButton
                  onClick={() => setOpenSafetySetting(true)}
                />
                {!row?.isDingTalk && (
                  <EditChildButton onClick={() => setOpenEditChild(true)} />
                )}
                <UnregisterButton
                  onClick={() => setOpenUnregister(true)}
                  isDingTalk={row?.isDingTalk}
                />
              </ButtonWrapper>
            )}
            overlayClassName="child-more-dropdown"
            getPopupContainer={() =>
              document.querySelector("child-customer-table") as HTMLElement
            }
          >
            <DropdownReference>
              {t("user_com_childManage_del_render_btn_more")}
              <DownOutlinedIcon />
            </DropdownReference>
          </Dropdown>
        </MoreOperationWrapper>
      </OperationWrapper>
      <MoreButtonDropdownStyle />
      <CreditModal
        open={openCredit}
        setOpen={setOpenCredit}
        {...row}
        isDingTalkSubAccount={row?.isDingTalk}
      />
      <EditChildModal
        open={openEditChild}
        setOpen={setOpenEditChild}
        {...row}
      />
      <SafetySettingModal
        open={openSafetySetting}
        setOpen={setOpenSafetySetting}
        {...row}
      />
      <UnregisterModal
        open={openUnregister}
        setOpen={setOpenUnregister}
        isDingTalkSubAccount={row?.isDingTalk}
        {...row}
      />
    </Fragment>
  );
}

const DropdownReference = styled.div`
  display: flex;
  align-items: center;
  color: var(--main-color);
  &:hover {
    > svg {
      transform: rotate(180deg);
      animation: 0.5s all;
    }
  }
`;

const OperationWrapper = styled.div`
  display: flex;
  position: relative;
`;

const MoreOperationWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const ButtonWrapper = styled.div`
  top: 100%;
  display: flex;
  flex-direction: column;
  background: #333336;
  border-radius: 2px;
  z-index: 1;
  button {
    width: 100%;
    padding: 5px 8px 5px 12px;
    text-align: start;
    color: rgba(255, 255, 255, 0.85);
    &:hover {
      background: rgba(19, 203, 117, 0.1);
      color: var(--main-color);
    }
  }
`;

const MoreButtonDropdownStyle = createGlobalStyle`
  .child-more-dropdown {
    .ant-dropdown-menu {
      background: transparent;
      border-radius: 4px;
      padding: unset !important;
    }
    .ant-dropdown-menu-item {
      padding: unset !important;
      &:hover {
        background: red !important;
        color: green !important;
      }
    }
  }
`;
